module.exports = __webpack_public_path__ + "img/baner-skoda.043bb6f3.png";